import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { Randomcode } from '../components/rendom_code';
import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';
 //help
import { VscArrowLeft } from "react-icons/vsc";
import { IoIosHelpCircle, IoIosHelpCircleOutline } from "react-icons/io";
 

//page links  
 
import PhoneCodeList from '../components/PhoneCodeList';
import { IoBusinessOutline } from "react-icons/io5";
import { Createcompany } from './create_company';
import './create-company-profile.css';
export default function Createcompanyprofile() {
    const location = useLocation();
    const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast(); 
  const [guid, setguid] = useState('');
  const [uid, setuid] = useState('');
  const [userlogin, setuserlogin] = useState(false);
  const [PhoneCodes, setPhoneCodes] = useState(null);
  const [countryname, setSelectedcountryname] = useState(null);
  const PhoneCodeListhandleChange = (selectedOption) => {
    setPhoneCodes(selectedOption.value);
    const countryName = selectedOption.label.split(" (")[0];
    setSelectedcountryname(countryName);
    // console.log("Selected Code:", selectedOption.value); 
    //document.querySelector('.phone-input').focus(); 
  };
  useEffect(() => {
    const existingUser = Cookies.get("guid");
    if (existingUser) {
      setguid(existingUser);
      setuserlogin(true);
    } else {
      navigate('/');
      setuserlogin(false);
    }
  }, []);
  const [keywords, setKeywords] = useState([]);
  const [input, setInput] = useState('');
  const [Companyinput, setCompanyinput] = useState('');
  const [Websiteinput, setWebsiteinput] = useState('');
  const [Descriptioninput, setDescriptioninput] = useState('');
  const [Addressinput, setAddressinput] = useState('');
  const [Cityinput, setCityinput] = useState('');
  const [Stateinput, setStateinput] = useState('');
  const [PostalCodeinput, setPostalCodeinput] = useState('');
  const [newpost, setnewpost] = useState(false);

        const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1); // Go back
    } else {
      navigate('/'); // No history, go to home
    }
  };


  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && input.trim() !== '' && keywords.length < 10) {
      e.preventDefault();
      const trimmed = input.trim();
      if (!keywords.includes(trimmed)) {
        setKeywords([...keywords, trimmed]);
      }
      setInput('');
    }
    if (e.key === ',' && input.trim() !== '' && keywords.length < 10) {
      e.preventDefault();
      const trimmed = input.trim();
      if (!keywords.includes(trimmed)) {
        setKeywords([...keywords, trimmed]);
      }
      setInput('');
    }
  };

  const removeKeyword = (index) => {
    setKeywords(keywords.filter((_, i) => i !== index));
  };
  function generateSlug(websiteName) {
    try {
      // Ensure the website name is a valid URL (if it doesn't start with 'http' or 'https', add 'https://')
      const url = new URL(websiteName.startsWith('http') ? websiteName : 'https://' + websiteName);

      // Extract the hostname (i.e., the domain part)
      let parts = url.hostname.split('.');

      // Remove the last part (extension) and the first 'www' part if present
      let mainPart = parts.length > 2 ? parts.slice(0, -1).join('_') : parts[0];

      // Remove 'www' if it's the first part
      if (mainPart.startsWith('www')) {
        mainPart = mainPart.slice(4); // Remove 'www' from the start
      }

      // Replace '.' with '_' and return the cleaned-up domain name
      return mainPart.toLowerCase().replace(/\./g, '_');
    } catch (e) {
      console.warn("Invalid website name:", websiteName);
      return '';
    }
  }


  const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
  const create_company = async (e) => {
    e.preventDefault();

    //if (!newpost || !guid || guid === "0") return;
    if (!Companyinput) {
      setLoading(false);
      showToast("Enter Company");
      return;
    }
    if (!keywords) {
      setLoading(false);
      showToast("Enter Industry");
      return;
    }
    if (!Websiteinput) {
      setLoading(false);
      showToast("Enter Website");
      return;
    }
    if (!urlPattern.test(Websiteinput)) {
      setLoading(false);
      showToast("Enter a valid website URL (e.g., https://example.com)");
      return;
    }
    if (!Descriptioninput) {
      setLoading(false);
      showToast("Enter Description");
      return;
    }
    if (!Addressinput) {
      setLoading(false);
      showToast("Enter Address");
      return;
    }
    if (!Cityinput) {
      setLoading(false);
      showToast("Enter City");
      return;
    }
    if (!PostalCodeinput) {
      setLoading(false);
      showToast("Enter Postal Code");
      return;
    }
    if (!Stateinput) {
      setLoading(false);
      showToast("Enter State");
      return;
    }
    if (!PhoneCodes) {
      setLoading(false);
      showToast("Enter Country");
      return;
    }
    const uid = Randomcode(11);

    setLoading(true);
    const IndustryJoined = keywords.join(", ");

    const result = await Createcompany({
      uid,
      companyname: Companyinput,
      industry: IndustryJoined,
      website: Websiteinput,
      icon: "https://firebasestorage.googleapis.com/v0/b/editortaskcom.firebasestorage.app/o/company_logo%2Flogo_icon.jpg?alt=media&token=3d1ad122-cda3-4ad4-9b38-181409b4e313",
      logo: "https://firebasestorage.googleapis.com/v0/b/editortaskcom.firebasestorage.app/o/company_logo%2Flogo.png?alt=media&token=c5abee51-1b5d-4f05-b1ea-4f5f9f1ec6e7",
      cover: "https://firebasestorage.googleapis.com/v0/b/editortaskcom.firebasestorage.app/o/company_logo%2Fcovers_img.jpg?alt=media&token=1b9aca37-292e-438a-87c2-19c02e19455b",
      rating: 0.1,
      reviws: 0,
      slug: generateSlug(Websiteinput) + "-" + uid,
      description: Descriptioninput,
      address: Addressinput,
      city: Cityinput,
      postalcode: PostalCodeinput,
      state: Stateinput,
      phonecode: PhoneCodes.replace("+", ""),
      country: countryname,
    });


    //  const result = await Createcompany({
    //   uid,
    //   companyname:Companyinput,
    //   Industry:IndustryJoined,  
    //   Website:Websiteinput,   
    //     slug:generateSlug(Websiteinput),
    //     description:Descriptioninput,
    //     address:Addressinput,
    //     city:Cityinput,
    //     postalcode:PostalCodeinput,
    //     state:Stateinput,
    //     phonecode:PhoneCodes,
    //     country:countryname,
    //   });  

    if (result.success) {
      setTimeout(() => {
        setLoading(false);
        setKeywords([]);
        navigate(`/verify-company-profile?uid=${uid}`, { replace: true });
      }, 1000);
    } else {
      setLoading(false);
      showToast("Failed");
    }
  };


  return (
    <div >
      <div className="status-bar">
        <div className="container_size">
          <div className="status-bar_size">
            <div className='left_body'>
              <VscArrowLeft onClick={handleGoBack} className='back_arrow_btn' />
            </div>
            <div className='name-bar-body'>Companys</div>
            <div className='right_body'>
              <div

                className={`help-button-icon ${location.pathname === '/help' ? 'active' : ''}`}
                title="Help Center"
              >
                {location.pathname === '/help' ? <IoIosHelpCircle className="icon" /> : <IoIosHelpCircleOutline className="icon" />}

                <span className="button-text">Help</span>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className='app_header_height'></div>
      <div className="container_roots">

        <Helmet>
          <title>EditorTask - India`s Trusted Platform for Jobs & Creative Talent</title>

          <meta name="description" content="Explore freelance opportunities, post job tasks, or showcase your creative work on EditorTask. Connecting job seekers and employers across India." />
          <meta name="keywords" content="job portal, freelance jobs, editor showcase, hire editors, post jobs, portfolio platform, task marketplace, India jobs, design gigs, video editing work" />
          <meta name="author" content="editortask.com" />
          <meta name="robots" content="index, follow" />

          <meta property="og:title" content="EditorTask - India’s Trusted Platform for Jobs & Creative Talent" />
          <meta property="og:description" content="Find talent or your next opportunity on EditorTask. Post tasks, showcase creative work, and hire skilled editors and freelancers." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.editortask.com/" />
          <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />

        </Helmet>

        <div className="container_size">
           <br/>
          <div className='post-container'>
            <div className='post_div post-body'>
              <div className='contact-title-div'>
                <div className='contact-title'>Create Your Company Profile</div>
                <div className='contact-details'>Fill in the details to showcase your company on our platform</div>
              </div>

              <br />

              <table className='data-input-body'>
                <tr><td className='lable-text'>
                  Company Name
                </td></tr>
                <tr><td >
                  <input className='bold-data-input'
                    onChange={(e) => setCompanyinput(e.target.value)}

                    maxLength={60} placeholder='Your Company name'></input>
                </td></tr>
                <tr><td className='lable-text'>
                  Company type: Add a new entry or use commas (,) to separate multiple
                </td></tr>
                <tr><td >
                  <div className="keyword-container">
                    {keywords.map((word, index) => (
                      <div key={index} className="keyword-chip">
                        {word}
                        <span className="remove" onClick={() => removeKeyword(index)}>×</span>
                      </div>
                    ))}
                    <input
                      value={input}
                      onChange={(e) => setInput(e.target.value)}
                      onKeyDown={handleKeyDown}
                      className="select_input_edit"
                      maxLength={100}
                      placeholder="Your Industry"
                    />
                  </div>
                </td></tr>
                <tr><td className='lable-text'>
                  Nature of business: Add a new entry or use commas (,) to separate multiple
                </td></tr>
                <tr><td >
                  <div className="keyword-container">
                    {keywords.map((word, index) => (
                      <div key={index} className="keyword-chip">
                        {word}
                        <span className="remove" onClick={() => removeKeyword(index)}>×</span>
                      </div>
                    ))}
                    <input
                      value={input}
                      onChange={(e) => setInput(e.target.value)}
                      onKeyDown={handleKeyDown}
                      className="select_input_edit"
                      maxLength={100}
                      placeholder="Your Industry"
                    />
                  </div>
                </td></tr>
                <tr><td className='lable-text'>
                  Industry: Add a new entry or use commas (,) to separate multiple
                </td></tr>
                <tr><td >
                  <div className="keyword-container">
                    {keywords.map((word, index) => (
                      <div key={index} className="keyword-chip">
                        {word}
                        <span className="remove" onClick={() => removeKeyword(index)}>×</span>
                      </div>
                    ))}
                    <input
                      value={input}
                      onChange={(e) => setInput(e.target.value)}
                      onKeyDown={handleKeyDown}
                      className="select_input_edit"
                      maxLength={100}
                      placeholder="Your Industry"
                    />
                  </div>
                </td></tr>
                <tr><td className='lable-text'>
                  Website
                </td></tr>
                <tr><td >
                  <input className='info-data-input' maxLength={60}
                    onChange={(e) => setWebsiteinput(e.target.value)}
                    placeholder='Your Website'></input>
                </td></tr>
                <tr><td className='lable-text'>
                  Description
                </td></tr>
                <tr><td >
                  <textarea className='data-input' maxLength={2000}
                    onChange={(e) => setDescriptioninput(e.target.value)}
                    placeholder='Your Business Description'></textarea>
                </td></tr>
                <tr><td className='lable-text'>
                  Address
                </td></tr>
                <tr><td >
                  <textarea className='data-input' maxLength={260}
                    onChange={(e) => setAddressinput(e.target.value)}
                    placeholder='Your Business Address'></textarea>
                </td></tr>
                <tr><td className='lable-text'>
                  City / Postal Code
                </td></tr>
                <tr><td >
                  <input className='info-data-input' maxLength={60}
                    onChange={(e) => setCityinput(e.target.value)}
                    placeholder='Your City'></input>
                  <input className='info-data-input' maxLength={10}
                    onChange={(e) => setPostalCodeinput(e.target.value)}
                    placeholder='Your Postal Code'></input>
                </td></tr>
                <tr><td className='lable-text'>
                  State
                </td></tr>
                <tr><td >
                  <div>
                    <input className='info-data-input' maxLength={60}
                      onChange={(e) => setStateinput(e.target.value)}
                      placeholder='Your State'></input>
                  </div>
                </td></tr>
                <tr><td className='lable-text'>
                  Country
                </td></tr>
                <tr><td >
                  <div className='Country-data-input'>
                    <PhoneCodeList
                      options={PhoneCodes}
                      placeholder="Select country"
                      onChange={PhoneCodeListhandleChange}
                    />
                  </div>
                </td></tr>
              </table>
              <br />
              <div className='button-ui' onClick={create_company}><IoBusinessOutline className='icon' />
                {loading ? <Lodinging /> : "Continue & Verify"}
              </div>
            </div>
            <div className='post_updates'>
              <div className='post_div' >
                <div className='guide-tipes-div'>
                  Use your official business name. If you're a freelancer or agency, use the name you want clients to recognize you by.
                </div>

                <div className='guide-tipes-div'>
                  <b>Choose the category that best fits your work:</b><br />
                  Agency, Startup, Freelancer, Studio, Enterprise, NGO<br />
                  This helps users understand what kind of organization you represent.
                </div>

                <div className='guide-tipes-div'>
                  <b>Upload your Company Logo:</b><br />
                  Use a high-quality image. Recommended size: 300x300px in JPG or PNG format. A clean logo builds trust and recognition.
                </div>

                <div className='guide-tipes-div'>
                  <b>Write a Tagline:</b><br />
                  Short and catchy – something that summarizes your company in one sentence. Example: “Innovative Design Solutions for Modern Brands.”
                </div>

                <div className='guide-tipes-div'>
                  <b>About the Company:</b><br />
                  Introduce your company in 2-3 small paragraphs. Mention services, experience, clients, or what makes your company unique.
                </div>

                <div className='guide-tipes-div'>
                  <b>Business Location:</b><br />
                  Add your city, state, and country to build authenticity and help connect locally.
                </div>

                <div className='guide-tipes-div'>
                  <b>Website and Social Links:</b><br />
                  Include your company website, LinkedIn, and social profiles. This shows your online presence and builds credibility.
                </div>

                <div className='guide-tipes-div'>
                  <b>Upload Work Samples:</b><br />
                  Show off your work! Upload images, project links, or portfolios. Visual proof boosts trust and profile quality.
                </div>

                <div className='guide-tipes-div'>
                  <b>Select Industries & Services:</b><br />
                  Choose the industries you serve and the services you offer. It helps potential clients and freelancers find you.
                </div>

                <div className='guide-tipes-div'>
                  <b>Contact Information:</b><br />
                  Make sure your email and phone are correct. You can decide what’s visible publicly.
                </div>

                <div className='guide-tipes-div'>
                  <b>Pro Tip:</b><br />
                  Keep your profile complete and professional. Add real content, avoid leaving fields blank, and update regularly to get more visibility.
                </div>

              </div>
            </div>
          </div>
          <br/>
        </div>
      </div>
    </div>
  );
}
